<template>
  <b-container fluid>
    <b-row align-h="center" align-v="start">
      <b-col md="4" sm="12">
        <b-overlay :show="show">
          <b-tabs small class="mt-2" fill>
            <b-tab :title="t('My info')">
              <b-form @submit.prevent="updateProfileInfo" class="pt-3">
                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="personal_info.first_name" required
                                  name="first_name"
                                  :placeholder="t('First name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="personal_info.father_name" required
                                  name="father_name"
                                  :placeholder="t('Father name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="personal_info.last_name" required
                                  name="last_name"
                                  :placeholder="t('Last name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="personal_info.mother_name" required
                                  name="mother_name"
                                  :placeholder="t('Mother name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" no-wheel v-model="patient_telecome.number" required
                                  name="mobile"
                                  :placeholder="t('Mobile number') + ' *'"
                                  type="tel"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="personal_info.identity_number_type"
                              required
                              name="identity_type">
                      <option :value="null" disabled>{{ t('ID type') }} *</option>
                      <option v-for="(id, value) in IDENTITY_TYPES[$translate.lang]"
                              :value="id" :key="id">
                        {{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" no-wheel v-model="personal_info.identity_number"
                                  name="identity_number"
                                  :placeholder="t('ID number') + ' *'"
                                  required
                                  type="tel"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="personal_info.gender" required>
                      <option :value="null" disabled>{{ t('Gender') }} *</option>
                      <option v-for="(id, value) in GENDERS[$translate.lang]" :value="id"
                              :key="id">
                        {{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="personal_info.nationality">
                      <option :value="null" disabled>{{ t('Nationality') }}</option>
                      <option v-for="nationality in NATIONALITIES" :value="nationality.id">
                        {{ nationality[nameKey] }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="personal_info.birthDate" required
                                  name="birth_date"
                                  :placeholder="t('Birth date') + ' *'" type="date"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="personal_info.marital_status">
                      <option :value="null" disabled>{{ t('Marital status') }}</option>
                      <option v-for="(id, value) in MARITAL_STATUS[$translate.lang]"
                              :value="id" :key="id">
                        {{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <v-select v-model="patient_address.area_id" :placeholder="t('Area') + ' *'"
                              :options="AREAS" :label="nameKey"
                              :reduce="area => area.id">
                      <template v-slot:search="{attributes, events}">
                        <input
                            class="vs__search"
                            :required="!patient_address.area_id"
                            v-bind="attributes"
                            v-on="events"
                        />
                      </template>
                    </v-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="patient_address.address" name="address"
                                  :placeholder="t('Address')"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <div class="d-flex justify-content-center mb-3">
                  <b-button variant="primary" type="submit">{{ t('Save') }}</b-button>
                </div>
              </b-form>
            </b-tab>

            <b-tab :title="t('ER Profile')">
              <b-form @submit.prevent="updateERProfile" class="pt-3">
                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="er_profile.first_name" required
                                  name="first_name"
                                  :placeholder="t('First name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="er_profile.last_name" required name="last_name"
                                  :placeholder="t('Last name') + ' *'"
                                  type="text"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" no-wheel v-model="er_profile.mobile" required
                                  name="mobile"
                                  :placeholder="t('Mobile number') + ' *'"
                                  type="tel"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="er_profile.gender" required>
                      <option :value="null" disabled>{{ t('Gender') }} *</option>
                      <option v-for="(id, value) in GENDERS[$translate.lang]" :value="id"
                              :key="id">
                        {{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="er_profile.relationship"
                              required name="kind_of_relationship">
                      <option :value="null" disabled>{{ t('Kind of relationship') }} *</option>
                      <option v-for="(value, id) in KIND_OF_RELATIONSHIPS[$translate.lang]"
                              :value="id" :key="id">{{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <div class="d-flex justify-content-center mb-3">
                  <b-button variant="primary" type="submit">{{ t('Save') }}</b-button>
                </div>
              </b-form>
            </b-tab>

            <b-tab :title="t('Sub account')">
              <b-form @submit.prevent="updateSubAccount" class="pt-3">
                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="sub_account.name"
                                  name="full_name"
                                  :disabled="subAccountDisabled"
                                  :placeholder="t('Full name') + ' *'" type="text"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input size="sm" v-model="sub_account.phone"
                                  no-wheel
                                  :disabled="subAccountDisabled"
                                  name="mobile"
                                  :placeholder="t('Mobile number') + ' *'"
                                  type="tel"></b-form-input>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="sub_account.relationship"
                              :disabled="subAccountDisabled"
                              name="kind_of_relationship">
                      <option :value="null" disabled>{{ t('Kind of relationship') }} *</option>
                      <option v-for="(value, id) in KIND_OF_RELATIONSHIPS[$translate.lang]"
                              :value="id" :key="id">{{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-select size="sm" v-model="sub_account.identity_number_type"
                              :disabled="subAccountDisabled"
                    >
                      <option :value="null" disabled>{{ t('ID type') }}</option>
                      <option v-for="(id, value) in IDENTITY_TYPES[$translate.lang]"
                              :value="id" :key="id">
                        {{ value }}
                      </option>
                    </b-select>
                  </b-input-group>
                </b-form-group>

                <b-form-group>
                  <b-input-group>
                    <b-form-input
                        size="sm"
                        no-wheel
                        v-model="sub_account.identity_number" name="identity_number"
                        :placeholder="t('ID number')"
                        :disabled="subAccountDisabled"
                        type="tel"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>

                <div class="d-flex justify-content-center mb-3">
                  <b-button :disabled="subAccountDisabled" variant="primary" type="submit" v-once>
                    {{ t('Save') }}
                  </b-button>
                </div>
              </b-form>
            </b-tab>
          </b-tabs>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'

export default {
  name: "Edit",
  inject: ['dataRepo', 'patientRepo'],
  components: {
    'v-select': vSelect
  },
  data: () => ({
    personal_info: {identity_number_type: null, nationality: null},
    patient_telecome: {},
    patient_address: {},
    er_profile: {gender: null, relationship: null},
    sub_account: {identity_number_type: null, relationship: null},
    IDENTITY_TYPES: [],
    GENDERS: [],
    NATIONALITIES: [],
    MARITAL_STATUS: [],
    AREAS: [],
    KIND_OF_RELATIONSHIPS: [],
    show: true
  }),
  computed: {
    nameKey() {
      return `name_${this.$translate.lang}`;
    },

    subAccountDisabled() {
      return !Boolean(this.sub_account.identity_number_type || this.sub_account.identity_number || this.sub_account.relationship || this.sub_account.name || this.sub_account.phone)
    }
  },
  methods: {
    updateProfileInfo() {
      this.show = true;

      this.patientRepo.update({
        personal_info: this.personal_info,
        patient_address: this.patient_address,
        patient_telecome: this.patient_telecome
      })
          .then((data) => {
            this.personal_info = data.data.patient;
            this.patient_telecome = data.data.patient_telecome;
            this.patient_address = data.data.patient_address;
            this.$swal.fire({
              icon: 'success',
              text: this.t('Success')
            })
          })
          .catch(err => this.$handleError(err))
          .finally(() => this.show = false)
    },

    updateERProfile() {
      this.show = true;

      this.patientRepo.updateERProfile(this.er_profile)
          .catch(err => this.$handleError(err))
          .finally(() => this.show = false)
    },

    updateSubAccount() {
      this.show = true;

      this.patientRepo.updateSubAccount(this.sub_account)
          .catch(err => this.$handleError(err))
          .finally(() => this.show = false);
    }
  },
  mounted() {
    Promise.all([this.dataRepo.signUp(), this.patientRepo.getUser(),])
        .then(([{data}, {patient, patient_telecome, patient_address, er_profile, sub_account}]) => {
          this.IDENTITY_TYPES = data.identity_types
          this.GENDERS = data.genders
          this.NATIONALITIES = data.countries
          this.MARITAL_STATUS = data.marital_status
          this.AREAS = data.areas
          this.KIND_OF_RELATIONSHIPS = data.kind_of_relationships
          this.personal_info = patient
          this.patient_telecome = patient_telecome
          this.patient_address = patient_address
          this.er_profile = er_profile
          this.sub_account = sub_account
          this.show = false;
        })
  }
}
</script>

<style scoped>

</style>
